import { AUTO_HIDE_DURATION } from "./snackbar";

export interface ISnackbarAlert {
  open: boolean;
  message: string;
  severity: "success" | "error" | "warning" | "info";
  autoHideDuration?: number;
}

export const INITIAL_SNACKBAR_STATE: ISnackbarAlert = {
  open: false,
  message: "",
  severity: "success",
  autoHideDuration: AUTO_HIDE_DURATION
};

export const setSuccessAlert = (message: string): ISnackbarAlert => {
  return {
    open: true,
    message: message,
    severity: "success",
    autoHideDuration: AUTO_HIDE_DURATION
  };
};

export const setErrorAlert = (message: string): ISnackbarAlert => {
  return {
    open: true,
    message: message,
    severity: "error",
    autoHideDuration: undefined
  };
};

export const setInfoAlert = (message: string): ISnackbarAlert => {
  return {
    open: true,
    message: message,
    severity: "info",
    autoHideDuration: undefined
  };
};

export const setWarningAlert = (message: string): ISnackbarAlert => {
  return {
    open: true,
    message: message,
    severity: "warning",
    autoHideDuration: undefined
  };
};

export const setInitialSnackbarState = (): ISnackbarAlert => {
  return {
    ...INITIAL_SNACKBAR_STATE
  };
};
